import React from 'react';
import './DispatchBoard.scss';
import { CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationStatus } from '../cancelConfirmation/CancelConfirmation';

export default class DriverJobFilledAssignment extends React.Component {
    isRemoveAllowed = () => {
        const { group, job, dayInt } = this.props;

        // job.canEdit is backed by whether or not the crew has submitted a timesheet.
        // if we have a timesheet for this crew for this day, we cannot remove the assignment.

        return (
            group.assignment.confirmationStatusId !=
                ConfirmationStatus.CancelPending &&
            !!job.assignments[dayInt].canEdit
        );
    };

    getEquipmentAssignments = () => {
        const { job, dayInt, assignmentIndex, group } = this.props;
        const equipmentAssignments = [];

        for (let i = 0; i < job.assignments[dayInt].equipment.length; i++) {
            const eq = job.assignments[dayInt].equipment[i];
            const staff = job.assignments[dayInt].staff[assignmentIndex];

            if (
                eq.assignedEmployee?.id != null &&
                eq.assignedEmployee?.id == group.assignment?.id
            ) {
                equipmentAssignments.push(eq);
            }

            if (eq.isBroker && staff.isBroker) {
                equipmentAssignments.push(eq);
            }
        }

        return equipmentAssignments;
    };

    render() {
        const { job, group, dayInt, onRemoveAssignment } = this.props;

        const equipmentAssignments = this.getEquipmentAssignments();

        return (
            <div className="card staffCard compact job-assignment-card driver-job-filled-assignment-card">
                <CardBody>
                    <CardTitle className="text-left d-flex flex-row align-items-center">
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: 0,
                                            padding: 0,
                                        }}
                                    >
                                        <span className="d-flex flex-row align-items-center">
                                            {!group.assignment && (
                                                <label className="mr-1 dropPlaceholder">{`${group.name}`}</label>
                                            )}

                                            <div className="d-flex flex-column">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: 0,
                                                                    padding: 0,
                                                                    verticalAlign:
                                                                        'middle',
                                                                }}
                                                                width="15%"
                                                            >
                                                                {this.isRemoveAllowed() && (
                                                                    <>
                                                                        <FontAwesomeIcon
                                                                            title="Remove this personnel"
                                                                            icon={
                                                                                faMinusCircle
                                                                            }
                                                                            style={{
                                                                                marginRight:
                                                                                    '10px',
                                                                            }}
                                                                            className="text-danger cursor-pointer"
                                                                            onClick={() =>
                                                                                onRemoveAssignment(
                                                                                    job,
                                                                                    group,
                                                                                    dayInt
                                                                                )
                                                                            }
                                                                        />
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: 0,
                                                                    padding: 0,
                                                                    textAlign:
                                                                        'left',
                                                                }}
                                                            >
                                                                <div className="assignment-main-text">
                                                                    <span>
                                                                        {
                                                                            group
                                                                                .assignment
                                                                                .name
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className={`assignment-status-text assignment-status-label ${group.assignment.confirmationStatusName
                                                                        .replace(
                                                                            ' ',
                                                                            ''
                                                                        )
                                                                        .toLowerCase()}`}
                                                                >
                                                                    {
                                                                        group
                                                                            .assignment
                                                                            .confirmationStatusName
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </span>
                                    </td>

                                    <td
                                        style={{
                                            border: 0,
                                            padding: 0,
                                            verticalAlign: 'middle',
                                            textAlign: 'right',
                                            paddingRight: '4px',
                                        }}
                                    >
                                        <table>
                                            <tbody>
                                                {equipmentAssignments.map(
                                                    (
                                                        equipmentAssignment,
                                                        i
                                                    ) => (
                                                        <tr key={`eqa-${i}`}>
                                                            <td
                                                                width="100%"
                                                                style={{
                                                                    border: 0,
                                                                    padding: 0,
                                                                    verticalAlign:
                                                                        'middle',
                                                                    textAlign:
                                                                        'right',
                                                                }}
                                                            >
                                                                {!equipmentAssignment?.isBroker && (
                                                                    <span className="assignment-side-text">
                                                                        {
                                                                            equipmentAssignment
                                                                                .assignment
                                                                                .description
                                                                        }
                                                                        &nbsp;
                                                                        <span
                                                                            style={{
                                                                                fontWeight:
                                                                                    'bold',
                                                                                color: '#909090',
                                                                            }}
                                                                        >
                                                                            (
                                                                            {
                                                                                equipmentAssignment
                                                                                    .assignment
                                                                                    ?.equipmentType
                                                                                    ?.description
                                                                            }
                                                                            )
                                                                        </span>
                                                                    </span>
                                                                )}

                                                                {equipmentAssignment?.isBroker && (
                                                                    <span className="assignment-side-text">
                                                                        {
                                                                            equipmentAssignment
                                                                                .assignment
                                                                                .description
                                                                        }
                                                                        &nbsp;
                                                                        <span
                                                                            style={{
                                                                                fontWeight:
                                                                                    'bold',
                                                                                color: '#909090',
                                                                            }}
                                                                        ></span>
                                                                    </span>
                                                                )}

                                                                <div>
                                                                    <span
                                                                        className={`text-right assignment-status-text assignment-status-label ${equipmentAssignment.assignment.confirmationStatusName
                                                                            .replace(
                                                                                ' ',
                                                                                ''
                                                                            )
                                                                            .toLowerCase()}`}
                                                                    >
                                                                        {
                                                                            equipmentAssignment
                                                                                .assignment
                                                                                .confirmationStatusName
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td
                                                                style={{
                                                                    border: 0,
                                                                    padding: 0,
                                                                    verticalAlign:
                                                                        'middle',
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    title="Remove this equipment"
                                                                    icon={
                                                                        faMinusCircle
                                                                    }
                                                                    size="lg"
                                                                    className="text-danger cursor-pointer"
                                                                    style={{
                                                                        marginLeft:
                                                                            '8px',
                                                                    }}
                                                                    onClick={() => {
                                                                        onRemoveAssignment(
                                                                            job,
                                                                            equipmentAssignment,
                                                                            dayInt
                                                                        );
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </CardTitle>
                </CardBody>
            </div>
        );
    }
}
